import { render, staticRenderFns } from "./ModoExibicao.vue?vue&type=template&id=1d1ce306"
import script from "./ModoExibicao.vue?vue&type=script&lang=js"
export * from "./ModoExibicao.vue?vue&type=script&lang=js"
import style0 from "./ModoExibicao.vue?vue&type=style&index=0&id=1d1ce306&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports